import { batch } from 'react-redux';
import { Pdp } from '@ff-os/pdp-shared-registry/Pdp';
import { toList } from '@ff-os/shared-utils/dictionaries';
import { upgrade } from '@ff-os/shared-utils/upgrades/upgrades';
import { selectActiveVariantId, selectAllVariants } from '@ff-scene-plugins/gift-redux/selectors/variantSelectors';
import { actions as inputActions } from '@ff-scene-plugins/gift-redux/slices/inputsSlice';
import { actions as metaActions } from '@ff-scene-plugins/gift-redux/slices/metaSlice';
import { actions as variableActions } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { actions as versionActions } from '@ff-scene-plugins/gift-redux/slices/versionSlice';
import { GiftPdpDispatch, GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { matchActiveVariant } from '@ff-scene-plugins/gift-shared/matchActiveVariant';
import { giftUpgrades } from '@ff-scene-plugins/gift-shared/upgrades/giftUpgrades';
import { updateActiveVariantId } from '../_redux-meta';
import { applyDefaultPrefabForActiveVariant } from '../helpers/applyDefaultPrefabForActiveVariant';
import { migratePinnedVariablesAndInputs } from './migratePinnedVariablesAndInputs';

export const openProject = async (
    loadedProject: GiftJson.Project,
    isCompatible: boolean,
    source: Pdp.Scene.ProjectSource,
    dispatch: GiftPdpDispatch,
    getState: () => GiftPdpState
) => {

    loadedProject = upgrade(loadedProject, { allUpgrades: giftUpgrades });

    const startupProject = getState().project as GiftJson.Project;
    const migratedProject = migrate(loadedProject, startupProject, isCompatible);

    batch(() => {

        dispatch(inputActions.upsertMany(toList(migratedProject.inputs.entities)));
        dispatch(variableActions.setAll(toList(migratedProject.variables.entities)));
        dispatch(metaActions.overwrite(migratedProject.meta));
        dispatch(versionActions.overwrite(migratedProject.version));

        const variants = selectAllVariants(getState());
        if (hasVariantChanged(migratedProject, variants)) {
            dispatch(updateActiveVariantId(selectActiveVariantId(getState())));
            applyDefaultPrefabForActiveVariant(dispatch, getState);
        }
    });

    return { continue: true };
};

const migrate = (
    loadedProject: GiftJson.Project,
    startupProject: GiftJson.Project,
    isCompatible: boolean
) => {
    if (!isCompatible) {
        return migratePinnedVariablesAndInputs(loadedProject, startupProject);
    } else {
        return loadedProject;
    }
};

const hasVariantChanged = (
    migratedProject: GiftJson.Project,
    variants: GiftJson.Variant<any>[]
) => {
    const activeVariantAfterMigration = matchActiveVariant(variants, migratedProject.inputs.entities);
    return activeVariantAfterMigration.id !== migratedProject.meta.activeVariantId;
};